<div class="container-fluid pb-1 mx-auto" style="background-color: #567ba0;">
    <div class="mx-auto" style="width: 90%;">
        <p class="mb-0">
          <a class="btn btn-xs text-light shadow-none align-middle px-0" (click)="closeModal()">
            <img src="./assets/images/arrow-left.svg" width="18px">
            Volver</a>
        </p>
        <h2 class="text-light mb-0">Orden de trabajo #{{ id }}</h2>
        <p class="mb-0">
            <button type="button" class="btn btn-danger btn-sm shadow-none align-middle px-2" (click)="downloadPDF()">
                <i class="fas fa-file-pdf me-1" aria-hidden="true"></i>
                Descargar PDF
            </button>
        </p>
    </div>
  </div>
  <form [formGroup]="requestForm">
        <div class="row my-3 mx-auto" style="width: 90%;">
            <div class="col-5">
                <div class="row mx-0 mb-3" style="justify-content: space-between;">
                    <div class="col-12">
                        <div class="row mb-2 position-relative">
                            <mdb-form-control class="custom-shadow">
                                <input mdbValidate mdbInput type="text" formControlName="productionLineSelected" class="form-control">
                                <label mdbLabel class="form-label">Línea</label>
                            </mdb-form-control>
                        </div>
                        <div class="row mb-2">
                            <mdb-form-control class="custom-shadow">
                                <input mdbValidate mdbInput type="text" formControlName="productionEquipmentSelected" class="form-control">
                                <label mdbLabel class="form-label">Equipo</label>
                            </mdb-form-control>
                        </div>
                        <div class="row mb-2">
                            <mdb-form-control class="custom-shadow">
                                <input mdbValidate mdbInput type="text" formControlName="productionSpecialitySelected" class="form-control">
                                <label mdbLabel class="form-label">Especialidad</label>
                            </mdb-form-control>
                        </div>
                        <div class="row mb-2">
                            <mdb-form-control class="custom-shadow">
                                <mdb-select placeholder="Tipo" [filter]="true" formControlName="type">
                                    <mdb-option [value]="" disabled>Seleccione Tipo</mdb-option>
                                    <mdb-option *ngFor="let item of types" [value]="item.name">
                                        {{ item.name }}
                                    </mdb-option>
                                </mdb-select>
                                <label mdbLabel class="form-label">Tipo</label>
                            </mdb-form-control>
                        </div>
                        <div class="row mb-2">
                            <mdb-form-control class="custom-shadow p-0">
                                <div class="form-check">
                                    <input type="checkbox" class="form-check-input" id="component_stock_verification" formControlName="component_stock_verification">
                                    <label class="form-check-label" for="component_stock_verification">Verificación de stock componentes</label>
                                </div>
                            </mdb-form-control>
                            <mdb-form-control class="custom-shadow p-0">
                                <div class="form-check">
                                    <input type="checkbox" class="form-check-input" id="is_necesary_stop_line" formControlName="is_necesary_stop_line">
                                    <label class="form-check-label" for="is_necesary_stop_line">¿Es necesario detener la línea?</label>
                                </div>
                            </mdb-form-control>
                        </div>
                        <div class="row mb-2">
                            <mdb-form-control class="custom-shadow">
                                <input mdbValidate mdbInput type="text" formControlName="schedule_date" class="form-control">
                                <label mdbLabel class="form-label">Fecha programada</label>
                            </mdb-form-control>
                        </div>
                        <div class="row mb-2">
                            <mdb-form-control class="custom-shadow">
                                <mdb-select [multiple]="true" formControlName="collabs">
                                  <mdb-option *ngFor="let option of collaborators" [value]="option.ID_USER">{{option.USER_NAME}}</mdb-option>
                                </mdb-select>
                                <label mdbLabel class="form-label">Seleccione colaboradores</label>
                              </mdb-form-control>
                        </div>
                        <div class="row mb-2 position-relative">
                            <mdb-form-control class="custom-shadow">
                                <textarea mdbValidate mdbInput placeholder="Comentarios para bodega" formControlName="comments_to_warehouse" rows="5" class="form-control"></textarea>
                                <label mdbLabel class="form-label">Comentarios para bodega</label>
                            </mdb-form-control>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-7">
                <div class="row mb-2">
                    <h4><strong>Validación por Bodega</strong></h4>
                </div>
                <div class="row mx-0 mb-3" style="justify-content: space-between;">
                    <div class="col-12">
                        <div class="row mb-2">
                            <mdb-form-control class="custom-shadow p-0">
                                <div class="form-check">
                                    <input mdbValidate mdbInput type="checkbox" class="form-check-input" formControlName="spare_parts_validation">
                                    <label mdbLabel class="form-check-label">Validación repuestos</label>
                                </div>
                            </mdb-form-control>
                        </div>
                        <div class="row mb-2">
                            <mdb-form-control class="custom-shadow">
                                <input mdbValidate mdbInput type="text" formControlName="delivery_date" class="form-control">
                                <label mdbLabel class="form-label">Fecha Entrega</label>
                            </mdb-form-control>
                        </div>
                        <div class="row mb-2 position-relative">
                            <mdb-form-control class="custom-shadow">
                                <textarea mdbValidate mdbInput placeholder="Comentario validación" formControlName="validation_comments" rows="5" class="form-control"></textarea>
                                <label mdbLabel class="form-label">Comentario validación</label>
                            </mdb-form-control>
                        </div>
                    </div>
                </div>
                <div class="datatable table-editor">
                    <table
                        class="table datatable-table"
                        mdbTable
                        mdbTableSort
                        #table="mdbTable"
                        #sort="mdbTableSort"
                        [dataSource]="maintenances"
                        [pagination]="pagination"
                        [sort]="sort"
                        width="100%"
                    >
                        <thead class="datatable-header">
                            <tr>
                                <ng-container *ngFor="let header of headers">
                                    <th
                                        [mdbTableSortHeader]="header.field"
                                        [disableSort]="header.disableSort"
                                        scope="col"
                                        class="py-2 align-middle th_3"
                                        style="white-space: normal;"
                                    >
                                        <strong>{{ header.label.replace("_", " ") | titlecase }}</strong>
                                    </th>
                                </ng-container>
                            </tr>
                        </thead>
                    
                        <tbody class="datatable-body">
                            <tr *ngIf="loading">
                                <td colspan="5" class="p-0 pt-1">
                                    <div class="px-2 bg-light py-5 text-center">
                                        <div width="150" class="spinner-border mt-5 opacity-50" role="status"></div>
                                        <p class="lead text-muted text-center mb-5">
                                            Cargando resultados...
                                        </p>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        
                        <tbody class="datatable-body">
                            <tr
                                *ngFor="let maintenance of maintenances; let index = index"
                                scope="row"
                                [cdkTrapFocus]="editElementIndex === index"
                                [cdkTrapFocusAutoCapture]="editElementIndex === index"
                                [ngClass]="{ 'edited-row': editElementIndex === index }"
                            >
                                <td class="table-cell py-1 px-4" style="white-space: normal;">
                                    <ng-container>
                                        <button class="btn btn-outline-success btn-sm w-50" type="button" [@buttonAnimation]>{{ maintenance.ID_MAINTENANCE_OT }}</button>
                                    </ng-container>
                                </td>
                                <td class="table-cell py-1 px-4" style="white-space: normal;">
                                    <ng-container>
                                        {{ maintenance.BINNACLE_OT_DATE }}
                                    </ng-container>
                                </td>
                                <td class="table-cell py-1 px-4" style="white-space: normal;">
                                    <ng-container>
                                        {{ maintenance.BINNACLE_OT_COMMENTS }}
                                    </ng-container>
                                </td>
                                <td class="table-cell py-1 px-4" style="white-space: normal;">
                                    <ng-container>
                                        <img 
                                            [src]="maintenance.BINNACLE_OT_PHOTO" 
                                            alt="Maintenance Image" 
                                            class="img-thumbnail" 
                                            style="max-width: 100px;" 
                                        />
                                    </ng-container>
                                </td>
                            </tr>
                        </tbody>
                    </table>
            
                    <mdb-table-pagination
                        #pagination
                        rowsPerPageText="Registros por Página"
                        ofText="de"
                        [disabled]="loading"
                        (paginationChange)="onPageChange($event)"
                    ></mdb-table-pagination>
                </div>
            </div>
        </div>
  </form>

  <mdb-loading [show]="loadingFull" [fullscreen]="true">
      <div class="loading-spinner">
          <div class="spinner-border loading-icon" role="status"></div>
          <span class="loading-text">Cargando datos...</span>
      </div>
  </mdb-loading>